import styled from 'styled-components'

import { BaseGameBox } from '../styles'

export const GameBox = styled(BaseGameBox)``
